import React, { useEffect, useState } from "react";
import configuration from "react-global-configuration";
import styles from './LandingPage.module.css';

const Header = (props) => {
    const [open, setOpen] = useState(false);

    const [staticPages2, setStaticPages2] = useState(
        configuration.get("configData.footer_pages2")
    );

    const findPage = (staticPages2, static_page_id) => {
        return staticPages2.find((obj) => {
            if (obj.static_page_id == static_page_id) {
                return obj.static_page_unique_id;
            } else {
                return "";
            }
        });
    };


    return (
        <>
            <header className={styles.header}>
                <div className={`${styles.landingContainer} ${styles.landingNav}`}>
                    <div className={styles.heroBannerEllipse}>
                        <img
                            src="https://admin.rebeltv.me/rebel-homepage-assets/ellipse.png"
                            alt=""
                        />
                    </div>

                    <a href="/" className={styles.logo} >
                        <img
                            src="https://admin.rebeltv.me/rebel-homepage-assets/rebel-logo.png"
                            alt="Rebel Logo"
                        />
                    </a>

                    <div className={styles.navRight}>
                        <ul className={`${styles.navLinks} ${open ? styles.active : ""
                            }`}>
                            <li><a href={"/page/" + findPage(staticPages2, 9)?.static_page_unique_id} target="_blank">How it Works</a></li>
                            <li><a href="/page/about" target="_blank">About Us</a></li>
                            <li><a href={
                                "/page/" + findPage(staticPages2, 10)?.static_page_unique_id
                            } target="_blank">Subscriber FAQ</a></li>
                            <li><a href={
                                "/page/" + findPage(staticPages2, 11)?.static_page_unique_id
                            } target="_blank">Creator FAQ</a></li>
                        </ul>

                        <a
                            className={styles.signupBtn}
                            href="/signin"
                        >
                            Sign In
                        </a>

                        <div className={styles.menuToggle} onClick={() => { console.log("clicked"); setOpen(!open) }}>☰</div>
                    </div>
                </div>
            </header>
        </>
    );
};

export default Header;